var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubcategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 135.46666 135.46667",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#be0a26",
      fillOpacity: 1,
      strokeWidth: 2.11667,
      strokeMiterlimit: 0
    },
    id: "rect837",
    width: 25.4,
    height: 25.4,
    x: 8.4666653,
    y: 16.933332,
    rx: 8.4666653,
    ry: 8.4666672
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#be0a26",
      fillOpacity: 1,
      strokeWidth: 2.11667,
      strokeMiterlimit: 0
    },
    id: "rect840",
    width: 84.666664,
    height: 25.4,
    x: 42.333332,
    y: 16.933332,
    rx: 8.4666662,
    ry: 8.4666662
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 2.11667,
      strokeMiterlimit: 0
    },
    id: "rect842",
    width: 25.4,
    height: 25.4,
    x: 8.4666634,
    y: 55.033333,
    rx: 8.4666653,
    ry: 8.4666672
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 2.11667,
      strokeMiterlimit: 0
    },
    id: "rect844",
    width: 84.666664,
    height: 25.4,
    x: 42.333332,
    y: 55.033333,
    rx: 8.4666662,
    ry: 8.4666662
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 2.11667,
      strokeMiterlimit: 0
    },
    id: "rect846",
    width: 25.4,
    height: 25.4,
    x: 8.4666672,
    y: 93.133331,
    rx: 8.4666653,
    ry: 8.4666672
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 2.11667,
      strokeMiterlimit: 0
    },
    id: "rect848",
    width: 84.666664,
    height: 25.4,
    x: 42.333332,
    y: 93.133331,
    rx: 8.4666662,
    ry: 8.4666662
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcategory);
export default __webpack_public_path__ + "static/media/subcategory.949d3e70676a3001f56e6631607b6a97.svg";
export { ForwardRef as ReactComponent };